import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { FC } from 'react';
import { useEffectOnce } from 'usehooks-ts';

import Button from 'common/Button';

import { LoginMethod } from 'types/AuthenticationV2';

import { handleCatch } from 'utils/errors';

import loginMessages from 'Login/messages';
import { AppDispatch } from 'store';
import { getLoginMethodSelectionThunk, loginMethodSelectionThunk } from 'store/auth/slice';
import makeSelectAuthRequired from 'store/auth/selectors';
import { OverrideNavigation } from 'Login/AuthV2/types';

const LoginMethodSelection: FC<OverrideNavigation> = ({ overrideNavigation, onNavigationOverride }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch<AppDispatch>();
  const { loginMethodSelectError, loginMethods: data } = useSelector(makeSelectAuthRequired());

  useEffectOnce(() => {
    const init = async () => {
      await dispatch(getLoginMethodSelectionThunk());
    };
    init().then();
  });

  const handleLoginMethodSelection = async (payload: LoginMethod) => {
    try {
      // TODO: Maybe RESET STORE
      await dispatch(loginMethodSelectionThunk({ loginMethodId: payload, overrideNavigation })).unwrap();
      if (overrideNavigation && onNavigationOverride) {
        onNavigationOverride();
      }
    } catch (error) {
      handleCatch(error);
    }
  };

  return (
    <div className="d-flex flex-column">
      <h3 className="text-center">{formatMessage(loginMessages.loginMethodSelection)}</h3>
      {loginMethodSelectError?.message && <p className="text-danger text-center">{loginMethodSelectError.message}</p>}
      {data?.map((method) => (
        <Button secondary className="m-1" key={method.id} onClick={() => handleLoginMethodSelection(method.id)}>
          {method.label}
        </Button>
      ))}
    </div>
  );
};

export default LoginMethodSelection;
